import React from "react";
import { useSelector } from "react-redux";
import { Container } from "react-bootstrap";
import "../../styles/ad-blogs/ad-blogs.css";
import { selectUser } from "../../components/auth/auth.selector";
import HelmetWrapper from "../../HelmetWrapper";
import CategoriesTab from "../../components/ad-blogs/categories/CategoriesTab";

const BlogCategories = () => {
  const userInfoData = useSelector(selectUser);

  return (
    <HelmetWrapper title="WTF: Blog Categories">
      <Container className="bg-cloud-k px-50px" fluid>
        <CategoriesTab userInfoData={userInfoData} />
      </Container>
    </HelmetWrapper>
  );
};

export default BlogCategories;
